import { DEFAULT_INTERFACE_LANGUAGE, SupportedLanguage, supportedLanguageKeys, supportedLanguages } from './types';

export const FREE_EDITION_LANGUAGE_STORAGE_KEY = 'sap.build.apps.language';

export const isSupportedLanguage = (language?: string | null): language is SupportedLanguage =>
  supportedLanguageKeys.includes(language as SupportedLanguage);

export const getMoreGeneralLanguage = (language?: string): SupportedLanguage | undefined => {
  if (!language) {
    return undefined;
  }

  return ['_', '-'].reduce(
    (foundCode, separator) => {
      if (foundCode) {
        return foundCode;
      }
      const [firstPart] = language.split(separator);
      return isSupportedLanguage(firstPart) ? firstPart : undefined;
    },
    undefined as SupportedLanguage | undefined,
  );
};

export const getPreferredLanguage = (language?: string): SupportedLanguage => {
  const snakeCased = language?.replace('-', '_');
  if (isSupportedLanguage(snakeCased)) {
    return snakeCased;
  }

  if (language === 'zh') {
    return 'zh_CN';
  }

  const generalization = getMoreGeneralLanguage(language);
  if (generalization) {
    return generalization;
  }

  const stored =
    typeof localStorage === 'undefined' ? undefined : localStorage.getItem(FREE_EDITION_LANGUAGE_STORAGE_KEY);
  return isSupportedLanguage(stored) ? stored : DEFAULT_INTERFACE_LANGUAGE;
};

export const getDocumentDirection = (language: SupportedLanguage): 'ltr' | 'rtl' => {
  const definition = supportedLanguages.find(({ key }) => key === language);
  if (definition && 'rtl' in definition) {
    return definition.rtl ? 'rtl' : 'ltr';
  }
  return 'ltr';
};

export const setDocumentDirection = (language: SupportedLanguage) => {
  if (typeof document !== 'undefined') {
    document.dir = getDocumentDirection(language);
  }
};
